var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mdc-card-media mdc-card__media mdc-card__media--16-9",style:('background-image: url(' + _vm.src + ')')},[_c('div',{staticClass:"mdc-card__media-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }